import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initializeOpenTelemetry } from './app/core/observability/otel-bootstrap';

if (environment.production) {
  enableProdMode();
}

initializeOpenTelemetry(environment.observability);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

